<template>
  <div class="content">
    <v-card class="d-flex pa-1 bg" outlined>
      <div class="mr-auto d-flex top-button-group">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" x-small right class="mb-2" color="primary" @click="expandAll()"><v-icon small>mdi-arrow-expand-all</v-icon></v-btn>
          </template>
          <span>{{ $t('common.unfold') }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" x-small right class="ml-1 mb-2" color="primary" @click="collapseAll()"><v-icon small>mdi-arrow-collapse-all</v-icon></v-btn>
          </template>
          <span>{{ $t('common.fold') }}</span>
        </v-tooltip>
      </div>
      <div class="top-button-group">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" :disabled="!savable" x-small right class="mb-2" color="primary" @click="save()"><v-icon small>mdi-content-save</v-icon></v-btn>
          </template>
          <span>{{ $t('common.save') }}</span>
        </v-tooltip>
      </div>
    </v-card>
    <v-row>
      <v-col cols="8">
        <v-card outlined min-height="300" @contextmenu="showContextMenu($event)">
          <v-card-actions id="droppable" drop-type="HEAD" outlined height="50">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" large>mdi-arrow-up-circle-outline</v-icon>
              </template>
              <span>{{ $t('sstmgrp.icon.top.group') }}</span>
            </v-tooltip>
          </v-card-actions>
          <vue-scrollbar :style="{ 'min-height': '300px' }">
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-treeview
              ref="group" :items="groups" item-key="id"
              expand-icon="mdi-chevron-down"
              hoverable activatable dense
              :active="actives" :open="opens"
            >
              <template v-slot:prepend="{ item, open }">
                <v-icon v-if="item.systemId == ''" small dense class="sts-menu-ic-mg">
                  {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                </v-icon>
                <v-icon v-else small dense class="sts-menu-ic-mg">
                  {{ 'mdi-monitor' }}
                </v-icon>
              </template>
              <!--
                Vuetify TreeView는 디폴트 동작이 이미 선택된 노드를 또 클릭하면 acrtive가 해제되어 버린다.
                이는 이 화면에서 원하지 않는 동작이다. 이미 선택된 노드를 클릭 시 이벤트가 발생하지 않도록 조치한다.
                2024.04.27.KWShin.
              -->
              <template v-slot:label="{ item, active }">
                <!-- eslint-disable-next-line prettier/prettier -->
                <div id="droppable" :drop-type="item.type" :drop-id="item.id" :draggable="active" 
                  style="width:100%;margin:-5px;padding:5px"
                  @click="active ? $event.stopPropagation() : null"
                  @contextmenu="showContextMenu($event, item, active)"
                  @dragstart="active ? dragAction($event, item) : null"
                >
                  {{ item.name }}
                </div>
              </template>
            </v-treeview>
          </vue-scrollbar>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card outlined min-height="300">
          <vue-scrollbar :style="{ 'min-height': '300px' }">
            <v-treeview ref="system" :items="systems" item-key="id" dense hoverable activatable>
              <!--
                Vuetify TreeView는 디폴트 동작이 이미 선택된 노드를 또 클릭하면 acrtive가 해제되어 버린다.
                이는 이 화면에서 원하지 않는 동작이다. 이미 선택된 노드를 클릭 시 이벤트가 발생하지 않도록 조치한다.
                2024.04.27.KWShin.
              -->
              <template v-slot:label="{ item, active }">
                <!-- eslint-disable-next-line prettier/prettier -->
                <div :draggable="active"
                  style="width:100%;margin:-5px;padding:5px"
                  @click="active ? $event.stopPropagation() : null"
                  @dragstart="active? dragAction($event, item) : null"
                >
                  {{ item.name }}
                </div>
              </template>
            </v-treeview>
          </vue-scrollbar>
          <v-card-actions id="droppable" drop-type="TRASH" outlined height="50">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" large>mdi-trash-can-outline</v-icon>
              </template>
              <span>{{ $t('sstmgrp.icon.trash') }}</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <!-- Drag & Drop 동작 시 움직이는 객체 -->
    <div ref="ball" v-show="dnd.show" class="ball" @dragstart="false">
      {{ dnd.label }}
    </div>
    <!-- 좌측 트리 영역이나 선택된 노드에서 우클릭시 등장하는 Context Menu 부분 -->
    <v-menu v-model="ctxtMenu.show" :position-x="ctxtMenu.x" :position-y="ctxtMenu.y" z-index="1000" absolute offset-y>
      <div class="border-wrap">
        <v-list>
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-list-item
            v-for="(menu, index) in ctxtMenu.menus" :key="index" :disabled="menu.disabled"
            style="min-height: 20px"
            @click="showEditDialog(menu.id)"
          >
            <v-list-item-icon class="mt-1 mb-1" style="align-self: auto !important;">
              <v-icon small>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="pt-1 pb-1">
              <v-list-item-title>{{ menu.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </v-menu>
    <!-- Context Menu 동작 시 등장하는 대화 화면 부분 -->
    <v-dialog v-model="dialog.show" persistent max-width="400px">
      <v-card :class="classContents">
        <v-card-title>
          <h3>{{ dialog.title }}</h3>
          <v-spacer></v-spacer>
          <v-btn icon x-small @click="dialogExit()">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="meta-form-pd">
          <p>{{ $t('sstmgrp.dialog.desc') }}</p>
        </v-card-text>
        <v-card-text class="meta-form-pd">
          <v-textarea v-model="dialog.groupNm" auto-grow outlined :hide-details="true" class="full-width-textarea"></v-textarea>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn @click="dialog.show = false" small>{{ this.$t('common.cancel') }}</v-btn>
          <v-btn @click="editGroup()" :disabled="!dialog.groupNm" small>{{ this.dialog.btnTitle }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { api } from '@/api/common/instances';
import { preset } from '@/preset';

export default {
  data() {
    return {
      groups: [],
      systems: [],
      opens: [],
      actives: [],
      savable: false,
      dnd: {
        show: false,
        label: '',
        currentDroppable: null,
        droppableBelow: null,
        dragType: '',
        dragId: '',
        dropType: '',
        dropId: '',
        dropStyle: '',
      },
      ctxtMenu: {
        show: false,
        x: 0,
        y: 0,
        menus: [
          { id: 'ADD', icon: 'mdi-plus-circle-outline', title: this.$t('sstmgrp.ctxt.menu.add'), disabled: false },
          { id: 'SUB', icon: 'mdi-plus-box-outline', title: this.$t('sstmgrp.ctxt.menu.sub'), disabled: false },
          { id: 'UPD', icon: 'mdi-pencil-box-multiple-outline', title: this.$t('sstmgrp.ctxt.menu.upd'), disabled: false },
        ],
      },
      dialog: {
        show: false,
        title: '',
        btnTitle: '',
        cmd: null,
        item: null,
        groupNm: '',
        itemId: -10,
      },
    };
  },
  methods: {
    /**
     * 좌측 TreeView를 품고 있는 Card에서 우클릭되거나
     * 좌측 TreeView의 active된 row에서 우클릭되면 Context Menu를 제공한다.
     */
    showContextMenu(e, item, active) {
      e.preventDefault();
      e.stopPropagation();
      if (item == undefined) {
        this.ctxtMenu.menus[0].disabled = false;
        this.ctxtMenu.menus[1].disabled = true;
        this.ctxtMenu.menus[2].disabled = true;
      } else {
        if (!active || item.type == 'STM') return;
        this.ctxtMenu.menus[0].disabled = true;
        this.ctxtMenu.menus[1].disabled = false;
        this.ctxtMenu.menus[2].disabled = false;
      }
      this.ctxtMenu.x = e.clientX;
      this.ctxtMenu.y = e.clientY;
      this.dialog.item = item;
      this.ctxtMenu.show = true;
    },
    /**
     * Context Menu에서 메뉴가 선택되면,
     * 선택된 메뉴 항목에 따라 적절한 내역으로 편집 대화창을 보여준다.
     */
    showEditDialog(cmd) {
      if (cmd == 'ADD' || cmd == 'SUB') {
        if (cmd == 'ADD') this.dialog.title = this.$t('sstmgrp.ctxt.menu.add');
        else this.dialog.title = this.$t('sstmgrp.ctxt.menu.sub');
        this.dialog.btnTitle = this.$t('common.add');
      } else if (cmd == 'UPD') {
        this.dialog.title = this.$t('sstmgrp.ctxt.menu.upd');
        this.dialog.groupNm = this.dialog.item.name;
        this.dialog.btnTitle = this.$t('common.edit');
      }
      this.dialog.cmd = cmd;
      this.dialog.show = true;
    },
    /**
     * 편집 대화창 우상단 X 버튼 클릭 시 대화창을 감춘다.
     */
    dialogExit() {
      this.dialog.show = false;
    },
    /**
     * 편집 대화창에서 그룹명이 입력되고 추가/수정 버튼이 클릭되면
     * Context Menu가 선택됐던 Node와 Context Menu 항목에 따라
     * 좌측 TreeView에 동작 결과를 반영한다.
     */
    editGroup() {
      if (this.dialog.cmd == 'ADD') {
        const newGrp = { id: this.dialog.itemId--, name: this.dialog.groupNm, systemId: '', type: 'GRP', children: [] };
        // actives를 초기화 시켜주고 $nextTick에서 노드를 추가해주어야
        // 최상위 그룹 추가시 노드의 active 상태가 꼬이지 않는다.
        this.actives = [];
        this.$nextTick(() => {
          this.groups.push(newGrp);
        });
      } else if (this.dialog.cmd == 'SUB') {
        const subGrp = { id: this.dialog.itemId--, name: this.dialog.groupNm, systemId: '', type: 'GRP', children: [] };
        this.dialog.item.children.push(subGrp);
      } else if (this.dialog.cmd == 'UPD') {
        this.dialog.item.name = this.dialog.groupNm;
      }
      this.dialog.groupNm = '';
      this.savable = true;
      this.dialog.show = false;
    },
    /**
     * 좌측 TreeView와 우측 TreeView에서 active된 노드는 draggable이 활성화되고 이 노드를 dragstart 하면 호출된다.
     */
    dragAction(event, item) {
      // 우선 브라우저의 디폴트 drag 기능을 막아준다.
      event.preventDefault();

      const vm = this;
      const ball = this.$refs.ball;
      // 보여준다고 신호를 주고
      vm.dnd.show = true;
      // 실제로 화면에 보여준 뒤에야 ball의 offsetWidth/Height가 잡힌다.
      // 그렇지 않으면 0으로 나오므로 ball의 위치가 마우스의 위치와 따로 놀아 이벤트가 제대로 먹지 않는다.
      // 이상이 $nextTick()을 사용한 이유이다.
      vm.$nextTick(() => {
        vm.dnd.label = item.name;

        // (1) absolute 속성과 zIndex 프로퍼티를 수정해 공이 제일 위에서 움직이기 위한 준비를 합니다.
        ball.style.position = 'absolute';
        ball.style.zIndex = 1000;

        // 현재 위치한 부모에서 body로 직접 이동하여
        // body를 기준으로 위치를 지정합니다.
        document.body.append(ball);

        // 포인터 아래로 공을 이동시킵니다.
        moveAt(event.pageX, event.pageY);
      });

      // 공을 pageX, pageY 좌표 좌상단에 위치하게 합니다.
      function moveAt(pageX, pageY) {
        ball.style.left = pageX - (ball.offsetWidth * 4) / 5 + 'px';
        ball.style.top = pageY - (ball.offsetHeight * 4) / 5 + 'px';
      }

      /*
       * DnD 상태에서 마우스가 droppable 객체의 영역에 진입했을 때의 동작을 정의한다.
       * Dragging 되고 있는 객체외 droppable 객체의 종류에 따라 동작이 달라진다.
       */
      function enterDroppable(droppable) {
        vm.dnd.dragType = item.type;
        vm.dnd.dragId = item.id;
        vm.dnd.dropType = droppable.getAttribute('drop-type');
        vm.dnd.dropId = droppable.getAttribute('drop-id');

        if ((vm.dnd.dragType == 'GRP' || vm.dnd.dragType == 'SSTM') && vm.dnd.dropType == 'GRP') {
          if (vm.dnd.dragId != vm.dnd.dropId) {
            if (vm.dnd.dragType == 'GRP' && vm.dnd.dropType == 'GRP') {
              const dragGrp = vm.getSelected(vm.groups, vm.dnd.dragId);
              // 자기 자신의 자식의 영역에 들어왔을 때에는 그냥 리턴.
              if (undefined != dragGrp.children?.find(child => child.id == vm.dnd.dropId)) return;
            }
            droppable.setAttribute('class', 'v-treeview-node__root v-treeview-node--active primary--text');
          }
        }
        if (vm.dnd.dragType == 'GRP' && vm.dnd.dropType == 'HEAD') {
          const idx = vm.groups.findIndex(grp => grp.id == vm.dnd.dragId);
          if (idx < 0) {
            vm.dnd.dropStyle = droppable.getAttribute('style');
            droppable.setAttribute('style', `background-color:${preset.theme.themes[vm.$vuetify.theme.isDark ? 'dark' : 'light'].primary}`);
          }
        }
        if ((vm.dnd.dragType == 'GRP' || vm.dnd.dragType == 'STM') && vm.dnd.dropType == 'TRASH') {
          vm.dnd.dropStyle = droppable.getAttribute('style');
          droppable.setAttribute('style', `background-color:${preset.theme.themes[vm.$vuetify.theme.isDark ? 'dark' : 'light'].primary}`);
        }
      }

      /*
       * DnD 상태에서 마우스가 droppable 객체의 영역을 떠날 때의 동작을 정의한다.
       */
      function leaveDroppable(droppable) {
        if ((vm.dnd.dragType == 'GRP' || vm.dnd.dragType == 'SSTM') && vm.dnd.dropType == 'GRP') {
          if (vm.dnd.dragId != vm.dnd.dropId) {
            droppable.setAttribute('class', 'v-treeview-node__root');
          }
        }
        if (vm.dnd.dragType == 'GRP' && vm.dnd.dropType == 'HEAD') {
          const idx = vm.groups.findIndex(grp => grp.id == vm.dnd.dragId);
          if (idx < 0) {
            droppable.setAttribute('style', vm.dnd.dropStyle);
          }
        }
        if ((vm.dnd.dragType == 'GRP' || vm.dnd.dragType == 'STM') && vm.dnd.dropType == 'TRASH') {
          droppable.setAttribute('style', vm.dnd.dropStyle);
        }
      }

      /*
       * DnD 상태에서 마우스가 움직일 때의 동작을 정의한다.
       * 마우스의 위치에 따라 Dragging되고 있는 객체를 표시하는 ball을 옮겨주고
       * droppable 객체의 영역에 마우스가 도달하였는 지 판단하여
       * droppable 객체의 영역에 진입하거나 벗어날 때 해당 동작을 보여주는 메소드를 호출한다.
       */
      function onMouseMove(event) {
        moveAt(event.pageX, event.pageY);

        ball.hidden = true;
        let elemBelow = document.elementFromPoint(event.clientX, event.clientY);
        ball.hidden = false;

        // 마우스 이벤트는 윈도우 밖으로 트리거 될 수 없습니다.(공을 윈도우 밖으로 드래그 했을 때)
        // clientX∙clientY가 윈도우 밖에 있으면, elementFromPoint는 null을 반환합니다.
        if (!elemBelow) return;

        // 잠재적으로 드롭 할 수 있는 요소를 'droppable' 클래스로 지정합니다.(다른 로직 가능)
        vm.dnd.droppableBelow = elemBelow.closest('#droppable');

        if (vm.dnd.currentDroppable != vm.dnd.droppableBelow) {
          // 들어오거나 날리거나...
          // 참고: 두 값 모두 null일 수 있습니다.
          //   currentDroppable=null 이벤트 전에 놓을 수 있는 요소 위에 있지 않다면(예: 빈 공간)
          //   droppableBelow=null 이벤트 동안 놓을 수 있는 요소 위에 있지 않다면

          if (vm.dnd.currentDroppable) {
            // '날아가는 것'을 처리하는 로직(강조 제거)
            leaveDroppable(vm.dnd.currentDroppable);
          }
          vm.dnd.currentDroppable = vm.dnd.droppableBelow;
          if (vm.dnd.currentDroppable) {
            // '들어오는 것'을 처리하는 로직
            enterDroppable(vm.dnd.currentDroppable);
          }
        }
      }

      // mousemove로 공을 움직입니다.
      document.addEventListener('mousemove', onMouseMove);

      /*
       * DnD 상태에서 마우스가 droppable 객체의 영역 내에 위치한 상태에서
       * Dnd 상태가 종료되면(마우스 클릭이 릴리즈되면) dragging되고 있는 객체와
       * droppable 객체에 따라 필요한 동작을 결정하고, DnD를 위해 등록했던 이벤트 핸들러들을 제거한다.
       */
      ball.onmouseup = function() {
        vm.dnd.show = false;
        document.removeEventListener('mousemove', onMouseMove);
        ball.onmouseup = null;
        if (vm.dnd.currentDroppable) {
          if ((vm.dnd.dragType == 'GRP' || vm.dnd.dragType == 'SSTM') && vm.dnd.dropType == 'GRP') {
            if (vm.dnd.dragId != vm.dnd.dropId) {
              if (vm.dnd.dragType == 'GRP' && vm.dnd.dropType == 'GRP') {
                const dragGrp = vm.getSelected(vm.groups, vm.dnd.dragId);
                // 자기 자신의 자식의 영역에 들어왔을 때에는 그냥 리턴.
                if (undefined != dragGrp.children?.find(child => child.id == vm.dnd.dropId)) return;
              }
              vm.dnd.currentDroppable.setAttribute('class', 'v-treeview-node__root');
              vm.actives = [vm.dnd.dropId];
              vm.opens.push(vm.dnd.dropId);
              if (vm.dnd.dragType == 'GRP') vm.moveGroup();
              if (vm.dnd.dragType == 'SSTM') vm.addSystem();
            }
          }
          if (vm.dnd.dragType == 'GRP' && vm.dnd.dropType == 'HEAD') {
            const idx = vm.groups.findIndex(grp => grp.id == vm.dnd.dragId);
            if (idx < 0) {
              vm.dnd.currentDroppable.setAttribute('style', vm.dnd.dropStyle);
              vm.moveGroup();
            }
          }
          if ((vm.dnd.dragType == 'GRP' || vm.dnd.dragType == 'STM') && vm.dnd.dropType == 'TRASH') {
            vm.dnd.currentDroppable.setAttribute('style', vm.dnd.dropStyle);
            vm.deleteNode();
          }
        }
      };
    },
    expandAll() {
      this.$refs.group.updateAll(true);
    },
    collapseAll() {
      this.$refs.group.updateAll(false);
      this.opens = [];
    },
    /**
     * 좌측 TreeView 내에서 그룹을 다른 그룹으로,
     * 또는 좌측 상단의 최상위 그룹 영역으로 DnD 했을 때의 동작을 정의한다.
     */
    moveGroup() {
      const dragGroup = this.getSelected(this.groups, this.dnd.dragId);
      const dropGroup = this.getSelected(this.groups, this.dnd.dropId);
      const delNode = (items, delItem) => {
        const idx = items.findIndex(item => item.id == delItem.id);
        if (idx > -1) items.splice(idx, 1);
        else {
          items.forEach(it => {
            if (it.children?.length) delNode(it.children, delItem);
          });
        }
      };
      delNode(this.groups, dragGroup);
      if (this.dnd.dropType == 'GRP') {
        dropGroup.children.push(dragGroup);
        this.savable = true;
      }
      if (this.dnd.dropType == 'HEAD') {
        // actives를 초기화 시켜주고 $nextTick에서 노드를 추가해주어야
        // 아래 레벨에서 최상위로 나온 노드의 active 상태가 꼬이지 않는다.
        this.actives = [];
        this.$nextTick(() => {
          this.groups.push(dragGroup);
          this.savable = true;
        });
      }
    },
    /**
     * 우측 TreeView의 시스템을 좌측 TreeView의 그룹에 DnD 했을 때의 동작을 정의한다.
     */
    addSystem() {
      const dropGroup = this.getSelected(this.groups, this.dnd.dropId);
      const dragSystem = this.getSelected(this.systems, this.dnd.dragId);
      const idx = dropGroup.children.findIndex(child => child.id == dragSystem.id || child.systemId == dragSystem.id);
      if (idx < 0) {
        const addSystem = cloneDeep(dragSystem);
        addSystem.type = 'STM';
        addSystem.systemId = addSystem.id;
        dropGroup.children.push(addSystem);
        this.savable = true;
      }
    },
    /**
     * 좌측 TreeView의 그룹이나 시스템을 우하단의 휴지통 영역에 DnD 했을 때의 동작을 정의한다.
     */
    deleteNode() {
      const dragNode = this.getSelected(this.groups, this.dnd.dragId);
      const delNode = (items, delItem) => {
        const idx = items.findIndex(item => item.id == delItem.id || item.systemId == delItem.id);
        if (idx > -1) items.splice(idx, 1);
        else {
          items.forEach(it => {
            if (it.children?.length) delNode(it.children, delItem);
          });
        }
      };
      delNode(this.groups, dragNode);
      this.savable = true;
    },
    /**
     * 변경사항을 저장할 것인지를 물어보고모든 변경사항을 DB에 반영하고
     * 화면의 좌측트리를 DB에서 다시 읽어온 data로 갱신한다.
     */
    async save() {
      if (await this.$dialog.confirm(this.$t('common.save.all.q'))) {
        await api.post('preference/groups', this.getFinalizeGroups());
        this.getGroups();
        this.savable = false;
      }
    },
    /**
     * 서버에서 노드ID와 노드의 순서를 완전히 새롭게 지정하여 DB에 저장할 수 있도록
     * name, systemId, children을 제외한 모든 데이터를 제거한 최종적인 데이터만 추출한다.
     */
    getFinalizeGroups() {
      const finalGroups = [];
      const finalizeGroups = (nodes, newBowl) => {
        nodes.forEach(node => {
          const fgrp = { name: node.name };
          newBowl.push(fgrp);
          if (node.systemId != undefined && node.systemId != null && node.systemId != '') fgrp.systemId = node.systemId;
          if (node.children?.length) {
            fgrp.children = [];
            finalizeGroups(node.children, fgrp.children);
          }
        });
      };
      finalizeGroups(this.groups, finalGroups);
      return finalGroups;
    },
    /**
     * Tree 노드의 ID값을 이용하여 재귀적 호출을 통해 Tree에서 해당 노드를 찾아낸다.
     */
    getSelected(items, itemKey) {
      for (let item of items) {
        if (item.id == itemKey) return item;
        let itemFinded = null;
        if (item.children) itemFinded = this.getSelected(item.children, itemKey);
        if (itemFinded) return itemFinded;
      }
    },
    /**
     * 시스템 그룹 데이터를 서버에서 조회하여 온다.
     * 노드를 'GROUP'과 'SYSTEM'으로 type 구분을 하여 좌측 트리 데이터를 생성한다.
     */
    async getGroups() {
      const data = (await api.get('/preference/groups')).data || [];
      const metaData = items => {
        items.map(item => {
          if (item.systemId == null || item.systemId == '') item.type = 'GRP';
          else item.type = 'STM';
          if (item.children.length) metaData(item.children);
        });
      };
      metaData(data);
      this.groups = data;
    },
    /**
     * 시스템 데이터를 서버에서 조회하여 온다.
     * 노드에 'source SYSTEM' type 구분을 추가하여 우측 트리 데이터를 생성한다.
     */
    async getSystems() {
      const data = (await api.get('/preference/systems')).data || [];
      const systems = data.map(item => ({ id: item.id, name: item.id, type: 'SSTM' }));
      this.systems = systems;
    },
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  /**
   * 컴포넌트가 생성되면, 시스템 그룹과 시스템 내역을 읽어와서 화면에 보여준다.
   */
  created() {
    this.getGroups();
    this.getSystems();
  },
};
</script>

<style scoped>
.content {
  min-width: 800px;
  height: 300px;
}
.ball {
  padding: 2px 6px 4px 6px;
  border: 2px solid gray;
  border-radius: 8px;
  color: gray;
}
.v-list-item {
  min-height: 28px;
}
</style>
